export const DAY_OFF_SERVICES = [
  "Day off",
  "Odmar 1",
  "Odmar 2",
  "Odmar 4",
  "Odmar 0.5",
]

const normalizeServiceName = (name) => (name ?? "").trim().toLowerCase()

const DAY_OFF_SERVICE_SET = new Set(
  DAY_OFF_SERVICES.map(normalizeServiceName)
)

export const isDayOffService = (serviceName) =>
  DAY_OFF_SERVICE_SET.has(normalizeServiceName(serviceName))

export const isCalendarServiceOption = (service) =>
  Boolean(service?.active) || isDayOffService(service?.en)

const DAY_OFF_SEARCH_ALIASES = [
  "перерыв",
  "перерывы",
  "break",
  "slobodan dan",
  "day off",
  "odmar",
]

export const serviceMatchesSearch = (service, query) => {
  const needle = (query ?? "").trim().toLowerCase()
  if (!needle) return true
  const fields = [service?.ru, service?.en, service?.sr]
  if (isDayOffService(service?.en)) {
    fields.push(...DAY_OFF_SEARCH_ALIASES)
  }
  return fields.some((value) =>
    String(value ?? "")
      .toLowerCase()
      .includes(needle)
  )
}

export const isDayOffRecord = (record) => {
  const candidates = [
    record?.service?.en,
    record?.service?.ru,
    record?.service?.sr,
    record?.en,
    record?.ru,
    record?.sr,
  ]
  return candidates.some(isDayOffService)
}
